module.exports = __webpack_public_path__ + "static/media/speedometer-blue.f84c33fc.svg";